<template>
  <div class="page-index" v-if="isDomain">
    <div class="component_layout">
      <index />
    </div>
  </div>
  <NuxtLayout v-else>
    <div class="page-index">
      <div
        v-for="element in componentList"
        :key="element.id"
        class="component_layout"
      >
        <index-banner
          v-if="element.type === 'banner'"
          :component-info="element"
        />

        <!-- 资源 -->
        <index-course
          v-if="
            element.type === 'course' && domain != 'hnkdtdxlkspx.ykumda.com'
          "
          :component-info="element"
        />
        <course-hnkj
          v-if="
            element.type === 'course' && domain == 'hnkdtdxlkspx.ykumda.com'
          "
          :component-info="element"
        />
        <index-grade
          v-if="element.type === 'grade'"
          :component-info="element"
        />
        <!-- 教师/团队 -->
        <index-teacher
          v-if="
            element.type === 'teacher' && domain != 'hnkdtdxlkspx.ykumda.com'
          "
          :component-info="element"
        />
        <teacher-hnkj
          v-if="
            element.type === 'teacher' && domain == 'hnkdtdxlkspx.ykumda.com'
          "
          :component-info="element"
        />
        <index-news v-if="element.type === 'news'" :component-info="element" />
        <index-ad v-if="element.type === 'ad'" :component-info="element" />
        <!-- 广告banner -->
        <index-patch-ad
          v-if="element.type === 'patchAd'"
          :component-info="element"
        />
        <index-advantage
          v-if="element.type === 'advantage'"
          :component-info="element"
        />
        <!-- 直播 -->
        <index-live
          v-if="element.type === 'live' && domain != 'hnkdtdxlkspx.ykumda.com'"
          :component-info="element"
        />
        <live-hnkj
          v-if="element.type === 'live' && domain == 'hnkdtdxlkspx.ykumda.com'"
          :component-info="element"
        />
      </div>
      <!-- 独家配套书籍 -->
      <index-books v-if="domain == 'edu.shanxiyixue.com' || domain == 'edu-test.ykumda.com' || domain == '192.168.10.87'"/>
      <material v-if="isDomain1" />
      <material />
      <readContract />
    </div>
    <!-- 精选试卷模块 -->
    <div class="course_wrapper w" v-if="domain == 'kaowu.ykumda.com' && paperList.length > 0">
      <div class="course_title">
        <div class="course_title_name">
          <index-title-icon />
          <span>精选试卷</span>
        </div>
        <NuxtLink to="/paper/list?practiceType=10&orderByType=2">
          <div class="course_title_more pointer">更多<i class="arrows" /></div>
        </NuxtLink>
      </div>

      <!-- 下面这一块全部换成了你要的样式 -->
      <div class="paper_list" v-if="paperList && paperList.length > 0">
        <div
          v-for="(item, index) in paperList"
          :key="index"
          class="practice_item_wrapper"
        >
          <div class="practice_item">
            <!-- 模拟考试图标 -->
            <img class="left_icon" src="@/assets/paper/mock_exam.svg" alt="" />

            <div>
              <p class="name font16">
                {{ item.courseName || "未命名试卷" }}
              </p>
            </div>

            <!-- 前往查看按钮 -->
            <div class="handle_view" @click="handleViewPaper(item)">
              前往查看
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>
import index from "./onlineExam/index.vue";
import material from "@/components/material/index";
import readContract from "@/components/readContract/index";
import { checkContractExist } from "@/api/user";
import { getComponentList, getComponentData } from "@/api/layouts";
import cookie from "@/utils/cookies";
import config from "~/config";
import { shopDataInfo } from "../api/system";
import liveHnkj from "@/components/index/Live/indexHnkj.vue";
import courseHnkj from "@/components/index/Course/indexHnkj.vue";
import teacherHnkj from "@/components/index/Teacher/indexHnkj.vue";
import { infoGet } from "@/api/layouts";
import { getSession, setSession, getStore, setStore } from "@/utils/storage";
import { useUserStore } from "@/stores/user";
import { getCourseList } from "../api/course";

const router = useRouter();
const route = useRoute();
const { getUserView } = useUserStore();

// 关键：存储当前域名
const currentDomain = ref("");

const { data: shopData } = await useAsyncData("course", async (ctx) => {
  let url = "";

  if (process.server) {
    url = ctx.ssrContext?.event?.req?.headers?.host;
  } else {
    url = window.location.host;
  }

  // 开发环境：用 config.url 店铺域名查店（与 server/middleware/shop.js 一致），避免 IP:端口查不到
  if (process.env.NODE_ENV === 'development' && config.url) {
    url = config.url;
  } else if (!url && config.url) {
    url = config.url;
  }

  currentDomain.value = url;
  return await shopDataInfo({ domain: url });
});

const cookieData = cookie.getShop();

// 计算属性：根据域名返回不同描述
const metaDescription = computed(() => {
  // 优先用请求头获取的域名
  const domain = currentDomain.value || "";

  // 卓越教育域名
  if (domain === "xue.coeedu.cn") {
    return '卓越教育是经教育行政主管部门批准设立的正规办学机构。卓越教育坚持"以终为始"的服务逻辑，从学员的职业目标与人生规划出发，反向设计课程体系与服务流程，确保每一项教学安排都紧扣学员的核心需求。卓越教育始终坚守办学规范，凭借齐全的资质、优质的教学与完善的服务，收获了行业与社会的广泛认可。';
  }

  // 国子教育域名
  if (domain === "guozijy.com" || domain === "www.guozijy.com") {
    return "";
  }

  // 其他域名：用 shopData 或 cookie 的数据
  return shopData.value?.shopIntroduce || cookieData.shopName || "";
});

useHead({
  meta: [
    { charset: "utf-8" },
    {
      key: "keywords",
      name: "keywords",
      content: () => shopData.value?.keywords || cookieData.shopName || "",
    },
    {
      key: "description",
      name: "description",
      content: () => metaDescription.value,
    },
  ],
  title: () => `${cookieData.shopName || ""}`,
});

const opts = reactive({
  componentEnum: {
    1: { name: "banner", listName: "detailList" },
    2: { name: "course", listName: "courseList" },
    3: { name: "grade", listName: "classroomList" },
    4: { name: "teacher", listName: "teacherList" },
    5: { name: "news", listName: "articleList" },
    6: { name: "ad", listName: "detailList" },
    7: { name: "patchAd", listName: "detailList" },
    9: { name: "advantage", listName: "detailList" },
    10: { name: "live", listName: "courseList" },
  },
});
const sessData1 = ref({});
const domain = ref("");
// 这个是默认的长江大学首页渲染
const componentList = ref([]);
const getTemplate = async () => {
  const result = await getComponentList();
  componentList.value = [];
  result.forEach((item) => {
    const c = opts.componentEnum[item.componentType];
    if (c && c.name) {
      const cp = {
        type: c.name,
        id: item.id,
        componentType: item.componentType,
        config: item,
        data: [],
      };
      componentList.value.push(cp);
    }
  });
  let count = 0;
  return new Promise((resolve) => {
    componentList.value.forEach(async (item) => {
      try {
        // console.log(userInfo());
        const res = await getComponentData({ id: item.id });
        item.data = res[opts.componentEnum[item.componentType].listName] || [];
        item.navList = res.navList || [];
      } catch (err) {}
      count++;
      if (count === componentList.value.length) {
        resolve(componentList.value);
      }
    });
  });
};

const isDomain = computed(() => {
  return domain.value == "drjy.ykexam.com";
  // return domain.value == "hnkdtdxlkspx.ykumda.com";
});
const isDomain1 = computed(() => {
  return domain.value == "edu.shanxiyixue.com";
  // return domain.value == "192.168.10.34";
});
const isDomain2 = computed(() => {
  return (
    domain.value == "hnkdtdxlkspx.ykumda.com" ||
    domain.value == "hnkdtdxlkcxx.ykumda.com" ||
    domain.value == "aufe.ykumda.com" ||
    domain.value == "cjdxyx.ykumda.com" ||
    domain.value == "cjdxtk.ykumda.com"
  );
  // return domain.value == "192.168.10.34";
});
// const enabledBranchShop = computed(() => {
//   const branchShop = shopData.value?.enabledBranchShop;
//   return branchShop;
// });

const userInfo = () => {
  let sessData = getSession("userInfo");
  if (sessData && typeof sessData == "string") {
    sessData = JSON.parse(sessData);
  }
  return sessData;
};
const indexUrl = ref("");
const getInfo = async () => {
  const res = await infoGet();
  indexUrl.value = res.indexUrl;
};
// -------------- 精选试卷 ----------------
const paperList = ref([]); // 试卷列表
const page = reactive({
  pageCurrent: 1,
  pageSize: 8,
  totalCount: 0,
  totalPage: 1,
});
const getPaperList = async () => {
  console.log("=== 试卷列表请求 ===");
  try {
    // 请求试卷接口
    const res = await getCourseList({
      pageCurrent: page.pageCurrent,
      pageSize: page.pageSize,
      courseType: "10",
      categoryId: "",
      chargeType: "",
      orderByType: 2,
      isCourseQuestion: 2,
    });
    console.log(res, "试卷列表");
    paperList.value = res?.list || [];
  } catch (err) {
    console.log(err, "试卷列表请求失败");
    paperList.value = [];
  }
};
// 精选试卷 - 点击查看
const handleViewPaper = (row) => {
  router.push({
    path: "/paper/childrenList",
    query: {
      id: row.id || row.goodsId,
    },
  });
};

onMounted(async () => {
  await getInfo();

  domain.value = window.location.hostname;

  // 先尝试从 sessionStorage 读取，如果没有则等待 getUserView 从 API 获取
  sessData1.value = userInfo();
  console.log(
    "3. sessionStorage 读取的用户信息:",
    sessData1.value ? "存在" : "不存在"
  );
  if (sessData1.value) {
    console.log("   - isReadContract:", sessData1.value.isReadContract);
    console.log("   - 用户ID:", sessData1.value.id || sessData1.value.userId);
  }

  // 如果 sessionStorage 中没有用户信息，但有 token，则等待从 API 获取
  if (!sessData1.value) {
    console.log("4. sessionStorage 中没有用户信息，尝试从 API 获取...");
    try {
      const userData = await getUserView();
      if (userData) {
        sessData1.value = userData;
        console.log("   ✅ 成功从 API 获取用户信息");
        console.log("   - isReadContract:", userData.isReadContract);
        console.log("   - 用户ID:", userData.id || userData.userId);
        console.log(
          "   - archiveStatus (用户信息中):",
          userData.archiveStatus,
          `(${typeof userData.archiveStatus})`
        );

        // 如果用户信息中包含归档状态，则保存到 localStorage（持久化保存）
        if (
          userData.archiveStatus !== undefined &&
          userData.archiveStatus !== null
        ) {
          console.log(
            "   - 从用户信息中获取到归档状态，保存到 localStorage:",
            userData.archiveStatus
          );
          setStore("archiveStatus", userData.archiveStatus);
          setSession("archiveStatus", userData.archiveStatus); // 同时保存到 sessionStorage 保持兼容
          // 验证保存
          const saved = getStore("archiveStatus");
          console.log(
            "   - 验证保存结果:",
            saved,
            saved ? "(已保存)" : "(保存失败)"
          );
        } else {
          console.log("   - ⚠️ 用户信息中不包含 archiveStatus 字段");
        }
      } else {
        console.log("   ❌ API 返回的用户信息为空");
      }
    } catch (err) {
      console.log("   ❌ 获取用户信息失败:", err);
      // 获取用户信息失败，可能未登录
    }
  } else {
    console.log("4. 使用 sessionStorage 中的用户信息");
    // 即使有 sessionStorage 中的用户信息，也检查是否包含归档状态
    if (
      sessData1.value.archiveStatus !== undefined &&
      sessData1.value.archiveStatus !== null
    ) {
      console.log(
        "   - 用户信息中包含归档状态:",
        sessData1.value.archiveStatus
      );
      setStore("archiveStatus", sessData1.value.archiveStatus); // 保存到 localStorage
      setSession("archiveStatus", sessData1.value.archiveStatus); // 同时保存到 sessionStorage 保持兼容
    }
  }

  if (isDomain2.value && !sessData1.value) {
    console.log("5. 需要登录的域名且未登录，跳转到登录页");
    router.replace({ path: "/login" });
    return;
  }

  // 获取归档状态并统一解析（处理布尔值和字符串）
  // 优先从用户信息中获取，如果没有则从 localStorage 读取（因为关闭浏览器后 sessionStorage 会清空）
  let archiveStatusRaw = null;
  if (
    sessData1.value &&
    sessData1.value.archiveStatus !== undefined &&
    sessData1.value.archiveStatus !== null
  ) {
    // 优先使用用户信息中的归档状态
    archiveStatusRaw = sessData1.value.archiveStatus;
    console.log(
      "6. 从用户信息中获取归档状态:",
      archiveStatusRaw,
      `(${typeof archiveStatusRaw})`
    );
  } else {
    // 先从 localStorage 读取（持久化存储，关闭浏览器后仍存在）
    const archiveStatusFromLocalStorage = getStore("archiveStatus");
    console.log(
      "6.1 从 localStorage 读取原始字符串:",
      archiveStatusFromLocalStorage
    );

    if (
      archiveStatusFromLocalStorage !== null &&
      archiveStatusFromLocalStorage !== undefined
    ) {
      try {
        archiveStatusRaw = JSON.parse(archiveStatusFromLocalStorage);
        console.log(
          "6.2 localStorage 解析后的值:",
          archiveStatusRaw,
          `(${typeof archiveStatusRaw})`
        );
      } catch (e) {
        // 如果不是 JSON 字符串，直接使用原始值
        archiveStatusRaw = archiveStatusFromLocalStorage;
        console.log("6.2 localStorage 解析失败，使用原始值:", archiveStatusRaw);
      }
    } else {
      // 如果 localStorage 也没有，再从 sessionStorage 读取（兼容旧代码）
      archiveStatusRaw = getSession("archiveStatus");
      console.log(
        "6.3 localStorage 中没有，从 sessionStorage 读取:",
        archiveStatusRaw,
        `(${typeof archiveStatusRaw})`
      );
    }
    console.log(
      "6. 最终获取的归档状态原始值:",
      archiveStatusRaw,
      `(${typeof archiveStatusRaw})`
    );
  }

  let finalArchiveStatus = null;
  if (archiveStatusRaw === true || archiveStatusRaw === "true") {
    finalArchiveStatus = true; // 已归档
  } else if (archiveStatusRaw === false || archiveStatusRaw === "false") {
    finalArchiveStatus = false; // 未归档
  } else {
    finalArchiveStatus = null; // 未设置
  }
  console.log(
    "   - 解析后的归档状态:",
    finalArchiveStatus,
    `(已归档: ${finalArchiveStatus === true ? "是" : "否"})`
  );

  // 检查 shopData - 优先使用 shopData.value，如果没有则从 sessionStorage 读取 shopInfo
  console.log("7. shopData 数据:");
  console.log("   - shopData.value 是否存在:", !!shopData.value);

  // 如果 shopData.value 为空，尝试从 sessionStorage 读取 shopInfo
  let shopInfoData = shopData.value;
  if (!shopInfoData) {
    const shopInfoFromStorage = getSession("shopInfo");
    if (shopInfoFromStorage) {
      try {
        shopInfoData = JSON.parse(shopInfoFromStorage);
        console.log(
          "   - ⚠️ shopData.value 为空，从 sessionStorage 读取 shopInfo"
        );
      } catch (e) {
        console.log("   - ⚠️ 解析 sessionStorage 中的 shopInfo 失败");
      }
    }
  }

  if (shopInfoData) {
    console.log("   - enabledBranchShop:", shopInfoData.enabledBranchShop);
    console.log("   - contractExist:", shopInfoData.contractExist);
  } else {
    console.log(
      "   - ⚠️ shopData.value 和 sessionStorage 中的 shopInfo 都为空"
    );
  }

  // 只有明确未归档（false）或未设置（null）时才跳转，已归档（true）不跳转
  // 避免在合同页面再次触发跳转
  console.log("8. 跳转条件检查:");
  const condition1 = !!sessData1.value;
  const condition2 = sessData1.value
    ? sessData1.value.isReadContract == false
    : false;
  const condition3 = !!shopInfoData;
  const condition4 = shopInfoData
    ? shopInfoData.enabledBranchShop == true
    : false;
  const condition5 = shopInfoData ? shopInfoData.contractExist == true : false;
  const condition6 = finalArchiveStatus !== true;
  const condition7 = route.path !== "/contract";

  console.log("   - 条件1: 用户信息存在?", condition1);
  console.log("   - 条件2: 未读合同 (isReadContract == false)?", condition2);
  console.log("   - 条件3: shopInfoData 存在?", condition3);
  console.log("   - 条件4: 分校开启 (enabledBranchShop == true)?", condition4);
  console.log("   - 条件5: 合同存在 (contractExist == true)?", condition5);
  console.log("   - 条件6: 未归档 (finalArchiveStatus !== true)?", condition6);
  console.log(
    "   - 条件7: 不在合同页面 (route.path !== '/contract')?",
    condition7
  );

  const shouldJump =
    condition1 &&
    condition2 &&
    condition3 &&
    condition4 &&
    condition5 &&
    condition6 &&
    condition7;
  console.log("9. 最终是否满足跳转条件:", shouldJump);

  if (shouldJump) {
    console.log("✅ 满足跳转条件，跳转到合同页面 /contract");
    router.replace({ path: "/contract" });
    return; // 跳转后立即返回，避免执行后续逻辑
  } else {
    console.log("❌ 不满足跳转条件，不跳转");
    if (!condition1) console.log("   原因: 用户信息不存在");
    if (condition1 && !condition2) console.log("   原因: 已读合同");
    if (!condition3) console.log("   原因: shopInfoData 不存在");
    if (condition3 && !condition4) console.log("   原因: 分校未开启");
    if (condition3 && !condition5) console.log("   原因: 合同不存在");
    if (!condition6) console.log("   原因: 已归档");
    if (!condition7) console.log("   原因: 已在合同页面");
  }
  // 如果是高校，并且配置了正确的域名跳转到动态渲染页
  if (shopData.value.enabledBranchShop == true && indexUrl.value) {
    console.log("indexUrl.value", indexUrl.value);
    // const urls = ['index_ahcj','index_hnkj_cjdx','index_hnkj','index_hnkj2']
    if (indexUrl.value == "index_home") {
      // console.log("url 正确")
      router.replace({ path: indexUrl.value });
    }
  }
  // const domain = window.location.hostname;
  // console.log("domain", domain.value);   //index_ahcj
  // 如果域名是安徽大学，并且没有配置域名  或者配置错误的域名 此时跳转到静态安徽页
  if (
    domain.value == "aufe.ykumda.com" &&
    (indexUrl.value == "" || indexUrl.value != "index_home")
  ) {
    // console.log("anhui ")
    router.replace({ path: "/index_ahcj" });
  } else if (domain.value == "cjdxyx.ykumda.com" && indexUrl.value == "") {
    // 如果域名是长江大学，并且没有配置域名  或者配置错误的域名 此时跳转到静态长江页
    router.replace({ path: "cj_home" });
  }

  getTemplate();
  // 长江大学首页功能
  // getTemplate2();
  const channel = new BroadcastChannel("unique_page_channel");
  // 监听来自其他页面的消息
  channel.onmessage = function (event) {
    if (event.data === "close") {
      // 接收到关闭消息时关闭页面
      window.close();
    }
  };

  // 发送消息告知其他页面已经打开
  channel.postMessage("open");
  // // debugger;
  // if (localStorage.getItem('isPageOpen')) {
  //   // 关闭之前已经打开的页面
  //   window.close();
  // } else {
  //   // 设置标记表示页面已经打开
  //   localStorage.setItem('isPageOpen', true);
  // }
  // if (process.client) {
  //     const route = window.location.host;
  //     if (route) {
  //       // redirect(route)
  //       window.close()
  //     }
  // }
  await getPaperList(); // 试卷数据请求
});
</script>
<style lang="scss" scoped>
/*  youke  替换成这个样式  */
.course_wrapper {
  width: 1200px;
  margin: 0 auto;
  padding-top: 25px;
  padding-bottom: 25px;
}
.course_title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 22px;
  color: #333;
  margin-bottom: 20px;
}
.course_title_name {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
}
.course_title_more {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
}

/* 👇 新样式 */
.paper_list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.practice_item_wrapper {
  margin-bottom: 20px;
  padding: 0 10px;
  width: 50%;
}

.practice_item {
  position: relative;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  column-gap: 12px;
  background: #ffffff;
  border: 1px solid #ebeef5;

  &:hover {
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
    transition: all 0.3s;
  }

  .name {
    width: 430px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .current_price {
    color: #f61818;
  }

  .free {
    color: #58b85c;
  }

  .line_price {
    text-decoration: line-through;
    margin-left: 5px;
  }

  .handle_view {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: rgba(61, 127, 255, 0.1);
    color: #3d7fff;
    padding: 6px 17px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
